<template>
  <div class="unify_pay">
    <van-cell-group>
      <van-cell title="订单" :value="value.title" size="large" />
      <van-cell title="价格" :value="`￥${value.price || 0}`" size="large" />
    </van-cell-group>

    <van-button type="primary" block :loading="loading" @click="onGet">支付</van-button>
  </div>
</template>

<script>
import { getWXPay } from '../../api/api-user';

export default {
  data() {
    return {
      value: {},
      loading: false,
    };
  },
  computed: {
    token() {
      return window.location.search.split('=')[1];
    },
  },
  mounted() {
    this.onGet();
  },
  methods: {
    async onGet() {
      try {
        const val = await getWXPay({ token: this.token });
        if (val) {
          const { title, price, ...data } = val;
          this.value = { title, price };
          const config = await this.payoffByWechat(data);
          if (config) {
            window.history.go(-1);
          }
        }
      } catch (error) {
        this.$toast.fail(error);
      }
    },
    payoffByWechat(data) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', data, res => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            resolve(true);
          } else {
            reject(res.errMsg || '请于15分钟内支付，过期订单将取消');
          }
        });
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.unify_pay {
  padding: 8px;
  .van-button {
    margin-top: 48px;
  }
}
</style>
